import React, { Component } from "react";
import { Form, Row, Col, Modal } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { alert } from "../../../../common/utils/alert";
import { LeftForm } from "./left-form";
import { RightForm } from "./right-form";
import { BottomButton } from "./bottom-button";
import { submit, driverConvert } from "../driver-list/driver-event";
import { apiDriver } from "../../../../api/api-driver";

const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};

const initialValues = {
  card_type: 1,
  accountStatus: 0,
  password: "Cus-0000",
  driver_status: "CDD",
  has_english: true,
  driver_account_status: true,
  certificate: true,
  employee_id: "",
};

//Sử dụng Ref cho vấn đề cập nhật lại UI trong các Component con
export class DriverDetail extends Component {
  driverParam = [];

  state = {
    editable: true,
    editPage: false,
    typeOption: "create_new",
    inactiveDelete: false,
    branches: [],
    supplierGroups: [],
    unitOperators: [],
    customerResource: false,
    inactiveDelete: false,
  };

  async componentDidMount() {
    const driverOptions = await apiDriver.getCreateDriverOptions();
    if (driverOptions.status === "success") {
      this.leftForm.setState({
        branches: driverOptions.data.branches.map((item) => {
          return { ...item, name: item.code };
        }),
        supplierGroups: driverOptions.data.supplier_groups,
      });
      if (this.state.typeOption === "create_new") {
        this.form.setFieldsValue({
          employee_id: driverOptions.data.code,
        });
      }
    }
  }

  submit = async () => {
    submit(this);
  };

  enableEdit = () => {
    this.setState({ editable: true, typeOption: "edit" });
  };

  cancelEdit = () => {
    this.setState({ editable: false, typeOption: "show_detail" });
  };

  deleteDriver = () => {
    Modal.confirm({
      title: "Xóa tài xế",
      icon: null,
      content: "Bạn có chắc chắn muốn xóa tài xế này không?",
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      confirmLoading: this.state.confirmLoading,
      onOk: async () => {
        this.setState({ confirmLoading: true });

        apiDriver
          .deleteDriver(this.state.driverIdEdit)
          .then((response) => {
            this.setState({ confirmLoading: false });
            if (response.status === "success") {
              alert("success", "Xóa tài xế thành công!");
              this.props.close();
            } else {
              alert("error", response.data.message);
            }
          })
          .catch((err) => {
            this.setState({ confirmLoading: false });
          });
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  onChangeForm = (feild, value) => {
    this.form &&
      this.form.setFieldsValue({
        [feild]: value,
      });
  };

  onChangeFormValues = (values) => {
    this.form.setFieldsValue({
      ...values,
    });
  };

  goToDriverDetail = () => {
    if (this.driverParam) this.updateFormDriver(this.driverParam);
  };

  updateFormDriver = (driver) => {
    this.driverParam = driver;

    if (driver.in_contract) {
      this.setState({
        inactiveDelete: true,
      });
    }
    this.setState({
      editable: false,
      typeOption: "show_detail",
      editPage: true,
      driverIdEdit: driver.id,
    });
    this.rightForm &&
      this.rightForm.setState({
        in_current_journey_diary: driver.current_journey_diary_id
          ? true
          : false,
        in_current_contract: driver.current_contract_id ? true : false,
        driverStatus: driver.status,
      });
    driverConvert(driver, this);
  };

  checkEditPass = (v) => {
    if (!this.state.checkEditPass) {
      this.setState({ checkEditPass: true });
      this.form.setFieldsValue({
        password: "",
      });
    } else {
      this.form.setFieldsValue({
        password: v,
      });
    }
  };

  setResources = (data) => {
    if (data.id === 3) {
      this.setState({
        customerResource: true,
      });
    } else {
      this.setState({
        customerResource: false,
      });
    }
    this.validateForm();
  };

  validateForm = () => {
    if (this.form) {
      const fieldsObject = this.form.getFieldsError();
      const fieldsErros = fieldsObject
        .filter((value) => {
          if (value.errors.length > 0) {
            return true;
          }
        })
        .map((value) => {
          if (value.name.length > 0) {
            return value.name[0];
          }
        });
      this.form.validateFields(fieldsErros);
    }
  };

  render() {
    const {
      typeOption,
      editable,
      editPage,
      inactiveDelete,
      branches,
      supplierGroups,
      unitOperators,
      customerResource,
    } = this.state;
    return (
      <div className="driver-detail">
        <div className="add-new-driver-title">
          <span onClick={this.props.close}>
            Danh sách tài xế
            <RightOutlined style={{ margin: "0px 7px" }} />
          </span>
          {typeOption === "create_new"
            ? "Thêm tài xế mới"
            : typeOption === "show_detail"
            ? "Chi tiết tài xế"
            : "Chỉnh sửa tài xế"}
        </div>
        <Form
          style={{ padding: "0px 10px" }}
          initialValues={initialValues}
          scrollToFirstError
          ref={(ref) => (this.form = ref)}
          {...layout}
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <LeftForm
                setResources={this.setResources}
                customerResource={customerResource}
                typeOption={typeOption}
                editable={editable}
                onChangeForm={this.onChangeForm}
                ref={(ref) => (this.leftForm = ref)}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <div style={{ position: "relative" }}>
                <RightForm
                  editable={editable}
                  editPage={editPage}
                  checkEditPass={this.checkEditPass}
                  customerResource={customerResource}
                  typeOption={typeOption}
                  onChangeForm={this.onChangeForm}
                  ref={(ref) => (this.rightForm = ref)}
                  onChangeFormValues={this.onChangeFormValues}
                />
              </div>
            </Col>
          </Row>
        </Form>
        <BottomButton
          typeOption={typeOption}
          enableEdit={this.enableEdit}
          submit={this.submit}
          cancelEdit={this.cancelEdit}
          close={this.props.close}
          goToDetailUser={this.goToDetailUser}
          userParam={this.userParam}
          deleteDriver={this.deleteDriver}
          inactiveDelete={inactiveDelete}
        />
      </div>
    );
  }
}
